function copy<T>(v: T) {
  return JSON.parse(JSON.stringify(v)) as Writeable<T>
}

type Writeable<T> = { -readonly [P in keyof T]: T[P] }

export { copy }
